<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane
        :key="treeDirectoryScope"
        :directory-scope="treeDirectoryScope"
        :pane-title="treePaneTitle"
        @tree-node-click="treeNodeClick"
      ></DepartmentPane>
    </section>
    <section class="dp-right">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="在线充值" name="online">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="学生" name="0">
              <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
              <!-- 列表：tbl-scroll-host + height 保证空状态可见、表体占满。最后更新：2026-08-31 -->
              <div class="tbl-scroll-host">
              <el-table height="100%" :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
                ref="table" style="width: 100%" class="custom-tbl">
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column prop="UserName" label="姓名" width="80"></el-table-column>
                <el-table-column prop="DepartmentName" label="部门" width="80"></el-table-column>
                <el-table-column prop="TradeNo" label="外部交易号"></el-table-column>
                <el-table-column prop="OrderNo" label="支付订单号"></el-table-column>
                <el-table-column prop="TotalAmount" label="支付金额" width="90"></el-table-column>
                <el-table-column label="支付方式" width="90">
                  <template slot-scope="scope">
                    <el-tag :type="getPayMethodType(scope.row)" size="mini" disable-transitions>
                      {{ getPayMethodText(scope.row) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="GmtPayment" label="支付时间"></el-table-column>
                <el-table-column prop="RefundAmount" label="退款金额"></el-table-column>
                <el-table-column prop="BuyerLogonId" label="买家账号"></el-table-column>
                <el-table-column prop="TradeStatus" label="状态">
                  <template slot-scope="scope">
                    <el-tag :type="getPayStatusType(scope.row)" disable-transitions>
                      {{ getPayStatusText(scope.row) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="90">
                  <template slot-scope="scope">
                    <el-button
                      v-if="canRefund(scope.row)"
                      type="danger"
                      size="mini"
                      plain
                      @click.stop="openRefundDialog(scope.row)"
                    >退款</el-button>
                  </template>
                </el-table-column>
              </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="教师" name="1">
              <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
              <div class="tbl-scroll-host">
              <el-table height="100%" :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
                ref="table" style="width: 100%" class="custom-tbl">
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column prop="UserName" label="姓名" width="80"></el-table-column>
                <el-table-column prop="DepartmentName" label="部门" width="80"></el-table-column>
                <el-table-column prop="TradeNo" label="外部交易号"></el-table-column>
                <el-table-column prop="OrderNo" label="支付订单号"></el-table-column>
                <el-table-column prop="TotalAmount" label="支付金额" width="90"></el-table-column>
                <el-table-column label="支付方式" width="90">
                  <template slot-scope="scope">
                    <el-tag :type="getPayMethodType(scope.row)" size="mini" disable-transitions>
                      {{ getPayMethodText(scope.row) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="GmtPayment" label="支付时间"></el-table-column>
                <el-table-column prop="RefundAmount" label="退款金额"></el-table-column>
                <el-table-column prop="BuyerLogonId" label="买家账号"></el-table-column>
                <el-table-column prop="TradeStatus" label="状态">
                  <template slot-scope="scope">
                    <el-tag :type="getPayStatusType(scope.row)" disable-transitions>
                      {{ getPayStatusText(scope.row) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="90">
                  <template slot-scope="scope">
                    <el-button
                      v-if="canRefund(scope.row)"
                      type="danger"
                      size="mini"
                      plain
                      @click.stop="openRefundDialog(scope.row)"
                    >退款</el-button>
                  </template>
                </el-table-column>
              </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane label="手动充值" name="manual">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="学生" name="0">
              <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
              <div class="tbl-scroll-host">
              <el-table height="100%" :data="manualUsers" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
                ref="table" style="width: 100%" class="custom-tbl">
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column prop="CreateBy" label="姓名" width=""></el-table-column>
                <el-table-column prop="DepartmentName" label="部门" width=""></el-table-column>
                <el-table-column prop="ChangeAmount" label="充值金额"></el-table-column>
                <el-table-column prop="CreateTime" label="充值时间"></el-table-column>
              </el-table>
              </div>
            </el-tab-pane>
            <el-tab-pane label="教师" name="1">
              <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
              <div class="tbl-scroll-host">
              <el-table height="100%" :data="manualUsers" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
                ref="table" style="width: 100%" class="custom-tbl">
                <el-table-column type="selection" width="50"></el-table-column>
                <el-table-column prop="CreateBy" label="姓名" width=""></el-table-column>
                <el-table-column prop="DepartmentName" label="部门" width=""></el-table-column>
                <el-table-column prop="ChangeAmount" label="充值金额"></el-table-column>
                <el-table-column prop="CreateTime" label="充值时间"></el-table-column>
              </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
      <el-dialog
        title="充值原路退款"
        :visible.sync="refundDialogVisible"
        width="480px"
        :close-on-click-modal="false"
        @close="resetRefundForm"
      >
        <el-form v-if="refundForm.order" label-width="100px" size="small">
          <el-form-item label="姓名">{{ refundForm.order.UserName }}</el-form-item>
          <el-form-item label="支付订单号">{{ refundForm.order.OrderNo }}</el-form-item>
          <el-form-item label="支付金额">{{ refundForm.order.TotalAmount }} 元</el-form-item>
          <el-form-item label="支付方式">{{ getPayMethodText(refundForm.order) }}</el-form-item>
          <el-form-item label="已退金额">{{ refundForm.order.RefundAmount || 0 }} 元</el-form-item>
          <el-form-item label="可退金额">{{ refundForm.maxRefund }} 元</el-form-item>
          <el-form-item label="退款金额" required>
            <el-input-number
              v-model="refundForm.amount"
              :min="0.01"
              :max="refundForm.maxRefund"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item>
            <span class="refund-tip">将原路退回用户支付账户，并同步扣减平台账户余额。</span>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="refundDialogVisible = false">取消</el-button>
          <el-button type="danger" :loading="refundSubmitting" @click="submitRefund">确认退款</el-button>
        </div>
      </el-dialog>
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>
    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getRechargeListPage, exportRechargeList, getManualRechargeListPage, exportManualRechargeList, exportRechargeSummary, refundRechargeOrder } from '../../api/modules/consumption';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      activeTab: "online", // online/manual
      activeName: "0", // 0学生 1教师
      filters: {},
      searchList: [
        { label: '姓名', key: 'name', width: '110px' },
        { label: '支付订单号', key: 'orderNo', width: '160px' },
        { label: '外部订单号', key: 'externalOrderNo', width: '160px' },
        { label: '开始日期', key: 'date', type: 'date', width: '160px' },
        { label: '结束日期', key: 'endDate', type: 'date', width: '160px' },
      ],
      buttonList: [],
      users: [],
      manualUsers: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [],
      currentRow: null,
      DepartmentId: "",
      refundDialogVisible: false,
      refundSubmitting: false,
      refundForm: {
        order: null,
        amount: 0,
        maxRefund: 0
      }
    };
  },
  computed: {
    /** 学生=家校，教师=内部通讯录。最后更新：2026-09-04 */
    treeDirectoryScope() {
      return String(this.activeName) === "1" ? "internal" : "teaching";
    },
    treePaneTitle() {
      return this.treeDirectoryScope === "internal" ? "内部通讯录" : "家校通讯录";
    },
  },
  methods: {
    getPayMethodText(row) {
      const remarks = ((row && row.Remarks) || '').trim();
      if (remarks === '微信充值') return '微信';
      if (remarks === '嘉联支付充值') return '嘉联';
      if (remarks === '支付宝充值' || remarks === '充值') return '支付宝';
      return remarks || '—';
    },
    getPayMethodType(row) {
      const text = this.getPayMethodText(row);
      if (text === '支付宝') return '';
      if (text === '微信') return 'success';
      if (text === '嘉联') return 'warning';
      return 'info';
    },
    isPaid(row) {
      return row.TradeStatus === 'TRADE_SUCCESS' || row.TradeStatus === 'SUCCESS';
    },
    getRefundableAmount(row) {
      const total = Number(row.TotalAmount) || 0;
      const refunded = Number(row.RefundAmount) || 0;
      const left = Math.round((total - refunded) * 100) / 100;
      return left > 0 ? left : 0;
    },
    canRefund(row) {
      if (!this.isPaid(row)) return false;
      if (this.getRefundableAmount(row) <= 0) return false;
      if (this.getPayMethodText(row) === '嘉联') return false;
      return true;
    },
    getPayStatusText(row) {
      if (!this.isPaid(row)) return '未支付';
      const refundable = this.getRefundableAmount(row);
      if (refundable <= 0) return '已退款';
      if (Number(row.RefundAmount) > 0) return '部分退款';
      return '已支付';
    },
    getPayStatusType(row) {
      const text = this.getPayStatusText(row);
      if (text === '已支付') return 'success';
      if (text === '部分退款') return 'warning';
      if (text === '已退款') return 'danger';
      return 'danger';
    },
    openRefundDialog(row) {
      const maxRefund = this.getRefundableAmount(row);
      this.refundForm = {
        order: { ...row },
        amount: maxRefund,
        maxRefund
      };
      this.refundDialogVisible = true;
    },
    resetRefundForm() {
      this.refundForm = { order: null, amount: 0, maxRefund: 0 };
      this.refundSubmitting = false;
    },
    submitRefund() {
      const { order, amount, maxRefund } = this.refundForm;
      if (!order || !order.Id) return;
      const refundAmount = Math.round(Number(amount) * 100) / 100;
      if (!refundAmount || refundAmount <= 0) {
        this.$message.warning('请输入退款金额');
        return;
      }
      if (refundAmount > maxRefund) {
        this.$message.warning(`退款金额不能超过可退金额 ${maxRefund} 元`);
        return;
      }
      this.$confirm(
        `确认为「${order.UserName}」原路退款 ${refundAmount} 元？退款后将从用户平台余额中扣减。`,
        '确认退款',
        { type: 'warning' }
      ).then(() => {
        this.refundSubmitting = true;
        refundRechargeOrder({ orderId: order.Id, refundAmount }).then((res) => {
          this.refundSubmitting = false;
          if (res.data && res.data.success) {
            this.$message.success(res.data.msg || '退款成功');
            this.refundDialogVisible = false;
            this.handleQuery();
          } else {
            this.$message.error((res.data && res.data.msg) || '退款失败');
          }
        }).catch(() => {
          this.refundSubmitting = false;
        });
      }).catch(() => {});
    },
    handleTabClick(tab) {
      this.page = 1;
      this.handleQuery();
    },
    handleClick(tab, event) {
      this.page = 1;
      this.DepartmentId = "";
      this.users = [];
      this.manualUsers = [];
      this.total = 0;
      // 切 Tab 后由部门树 :key 重载并自动选中节点触发查询
    },
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) return;
      if (row) this.selectCurrentRow(row);
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = { key: item.search }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: this.activeName
      };
      this.listLoading = true;
      if (this.activeTab === "online") {
        getRechargeListPage(para).then((res) => {
          this.total = res.data.response.dataCount;
          this.users = res.data.response.data;
          this.listLoading = false;
        });
      } else {
        getManualRechargeListPage(para).then((res) => {
          this.total = res.data.response.dataCount;
          this.manualUsers = res.data.response.data;
          this.listLoading = false;
        });
        this.listLoading = false;
      }
    },
    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters,
          type: this.activeName
        };
        let fileName = '';
        let response;
        if (this.activeTab === 'online') {
          fileName = this.activeName == 0 ? "学生用户充值记录" : "教师用户充值记录";
          response = await exportRechargeList(para);
        } else {
          fileName = this.activeName == 0 ? "学生手动充值记录" : "教师手动充值记录";
          response = await exportManualRechargeList(para);
        }
        if (!response.data) {
          this.$message({ message: "导出数据为空", type: "error" });
          return;
        }
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },

    async exportSummary() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters,
          type: this.activeName
        };
        let fileName = '充值汇总表';
        let response;
        response = await exportRechargeSummary(para);
        if (!response.data) {
          this.$message({ message: "导出数据为空", type: "error" });
          return;
        }
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.refund-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

</style>